import { Component, ViewChild } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { COLOR_PRIMARY_CONTRAST_500, LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { OrdersDataComponent } from '../orders-data/orders-data.component';
import { OrdersSummaryComponent } from '../orders-summary/orders-summary.component';
import { DialogService } from 'src/app/core/dialog.service';
import { OrdersFilterDialogComponent } from '../orders-filter-dialog/orders-filter-dialog.component';
import { OrdersFiltersComponent } from '../orders-filters/orders-filters.component';
import { ListOrdersParams } from 'src/app/core/orders.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
})
export class OrdersComponent {
  @ViewChild(OrdersSummaryComponent) summary_component?: OrdersSummaryComponent;
  @ViewChild(OrdersDataComponent) data_component?: OrdersDataComponent;
  @ViewChild(OrdersFiltersComponent) filters_component?: OrdersFiltersComponent;
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.orders);
  filters?: ListOrdersParams;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private meta: Meta,
    private dialog_service: DialogService,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
  }

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
  }

  onRefresh(): void {
    this.onFilterClear({});
    this.summary_component?.onRefresh();
    //this.data_component?.onRefresh();
  }

  onFilter(): void {
    this.dialog_service
      .openDialog(OrdersFilterDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.params) {
          this.filters = dialog_result.params;
          console.log(this.filters, 2, null);
          this.setDataFilters();
        }
      });
  }

  onFilterClear(filters: ListOrdersParams): void {
    this.filters = filters;
    this.setDataFilters();
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  setDataFilters(): void {
    if (this.areFiltersSet()) {
      this.data_component?.onFilter(this.filters);
    }

    if (!this.areFiltersSet()) {
      this.data_component?.onFilter();
    }
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }

  areFiltersSet(): boolean {
    if (this.filters) {
      const active_filters = Object.keys(this.filters).filter(k => {
        return this.isKeySet(k);
      });
      return active_filters && active_filters.length ? true : false;
    }
    return false;
  }

  isKeySet(key: string): boolean {
    if (!this.filters) return false;
    return this.utils_service.isFilterKeySet(this.filters, key);
  }
}
